// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__3khS-","opened":"Arrow_opened__1S8dO"};